import { SideModal } from "shared";
import SVG from "shared/SVG";
import { SVG_ENUM } from "enums";
import "./PreciousStonesDetailsSideModal.scss";

interface PreciousStonesDetailsSideModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: any | null;
}

const PreciousStonesDetailsSideModal = ({
  isOpen,
  onClose,
  item,
}: PreciousStonesDetailsSideModalProps) => {
  const contractFiles = (item?.files ?? []).filter(
    (f: any) => f.role === "contract",
  );

  const handleDownloadAll = () => {
    if (!item) return;
    contractFiles.forEach((file: any) => {
      const link = document.createElement("a");
      link.href = file.file.url;
      link.download = file.file.name;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const formatPrice = () => {
    if (!item?.primaryValue) return "Brak";
    const formatted = Number(item.primaryValue).toLocaleString("pl-PL", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    const currency = item.currency?.currency ?? "";
    return currency ? `${formatted} ${currency}` : formatted;
  };

  return (
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Szczegółowe informacje"
      subtitle="Aktywo: Kamienie szlachetne"
      className="side-modal--precious-stones-details"
    >
      <div className="precious-stones-details">
        <div className="precious-stones-details__price-header">
          Cena zakupu: <span>{formatPrice()}</span>
        </div>

        <div className="precious-stones-details__field">
          <span className="precious-stones-details__label">Nazwa</span>
          <span className="precious-stones-details__value">
            {item?.name || "Brak"}
          </span>
        </div>

        <div className="precious-stones-details__field">
          <span className="precious-stones-details__label">Cena zakupu</span>
          <span className="precious-stones-details__value">{formatPrice()}</span>
        </div>

        <div className="precious-stones-details__field">
          <span className="precious-stones-details__label">Waluta</span>
          <span className="precious-stones-details__value">
            {item?.currency?.currency || "Brak"}
          </span>
        </div>

        <div className="precious-stones-details__field">
          <span className="precious-stones-details__label">Masa</span>
          <span className="precious-stones-details__value">
            {item?.details?.weight != null ? `${item.details.weight}g` : "Brak"}
          </span>
        </div>

        <div className="precious-stones-details__field">
          <span className="precious-stones-details__label">Szlif</span>
          <span className="precious-stones-details__value">
            {item?.details?.cut || "Brak"}
          </span>
        </div>

        <div className="precious-stones-details__field">
          <span className="precious-stones-details__label">Barwa</span>
          <span className="precious-stones-details__value">
            {item?.details?.color || "Brak"}
          </span>
        </div>

        <div className="precious-stones-details__field">
          <span className="precious-stones-details__label">Czystość</span>
          <span className="precious-stones-details__value">
            {item?.details?.clarity || "Brak"}
          </span>
        </div>

        <div className="precious-stones-details__field">
          <span className="precious-stones-details__label">
            Dodatkowe informacje
          </span>
          <span className="precious-stones-details__value">
            {item?.additionalInfo || "Brak"}
          </span>
        </div>

        <div className="precious-stones-details__field precious-stones-details__field--files">
          <div className="precious-stones-details__files-header">
            <span className="precious-stones-details__label">Umowa</span>
            {contractFiles.length > 0 && (
              <button
                className="precious-stones-details__download-all"
                onClick={handleDownloadAll}
              >
                Pobierz wszystko
                <SVG type={SVG_ENUM.FILE_DOWNLOAD} />
              </button>
            )}
          </div>
          {contractFiles.length === 0 ? (
            <span className="precious-stones-details__value">Brak</span>
          ) : (
            <div className="precious-stones-details__files-list">
              {contractFiles.map((file: any) => (
                <div
                  key={file.file.uuid}
                  className="precious-stones-details__file-item"
                >
                  <span className="precious-stones-details__file-name">
                    {file.file.name}
                  </span>
                  <a
                    href={file.file.url}
                    download={file.file.name}
                    target="_blank"
                    rel="noreferrer"
                    className="precious-stones-details__file-download"
                  >
                    <SVG type={SVG_ENUM.FILE_DOWNLOAD} />
                  </a>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </SideModal>
  );
};

export default PreciousStonesDetailsSideModal;
